module.exports = "pegasus_template/assets/preview-11.png";